"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commandFailedEventHandler = exports.commandStartedEventHandler = exports.singleEventTypeHandler = exports.anyDashboardEventHandler = exports.anyEventHandler = void 0;
var events_1 = require("../events");
/**
 * Creates a {@link DashboardEventHandler} instance that will be invoked for any event (event for custom events).
 *
 * @param handler - the actual event handling function
 * @public
 */
function anyEventHandler(handler) {
    return {
        eval: function () { return true; },
        handler: handler,
    };
}
exports.anyEventHandler = anyEventHandler;
/**
 * Creates a {@link DashboardEventHandler} instance that will be invoked for any dashboard event (i.e. not for custom events).
 *
 * @param handler - the actual event handling function
 * @public
 */
function anyDashboardEventHandler(handler) {
    return {
        eval: events_1.isDashboardEvent,
        handler: handler,
    };
}
exports.anyDashboardEventHandler = anyDashboardEventHandler;
/**
 * Creates a {@link DashboardEventHandler} instance that will be invoked for one specified event type.
 *
 * @param type - the type of event this handler should trigger for
 * @param handler - the actual event handling function
 * @public
 */
function singleEventTypeHandler(type, handler) {
    return {
        eval: function (e) { return e.type === type; },
        handler: handler,
    };
}
exports.singleEventTypeHandler = singleEventTypeHandler;
/**
 * Creates a {@link DashboardEventHandler} instance that will be invoked for a DashboardCommandStarted of a particular command.
 *
 * @param type - the type of command the DashboardCommandStarted of which this handler should trigger for
 * @param handler - the actual event handling function
 * @alpha
 */
function commandStartedEventHandler(type, handler) {
    return {
        eval: function (e) { return events_1.isDashboardCommandStarted(e) && e.payload.command.type === type; },
        handler: handler,
    };
}
exports.commandStartedEventHandler = commandStartedEventHandler;
/**
 * Creates a {@link DashboardEventHandler} instance that will be invoked for a DashboardCommandFailed of a particular command.
 *
 * @param type - the type of command the DashboardCommandFailed of which this handler should trigger for
 * @param handler - the actual event handling function
 * @alpha
 */
function commandFailedEventHandler(type, handler) {
    return {
        eval: function (e) { return events_1.isDashboardCommandFailed(e) && e.payload.command.type === type; },
        handler: handler,
    };
}
exports.commandFailedEventHandler = commandFailedEventHandler;
//# sourceMappingURL=eventHandler.js.map